import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CmxLayoutService } from '../../../services/cmx-layout.service';

@Component({
  selector: 'cmx-chatbox',
  templateUrl: './cmx-chatbox.component.html',
  styleUrls: ['./cmx-chatbox.component.scss'],
})
export class CmxChatboxComponent implements OnInit, OnDestroy {
  public isMobile: boolean;
  public isCollapsed: boolean;
  public isRtl: boolean;

  private subscriptions: Subscription[] = [];

  constructor(public layout: CmxLayoutService) {}

  ngOnInit() {
    this.subscriptions.push(
      this.layout.isMobile.subscribe((value) => (this.isMobile = value)),
      this.layout.direction.subscribe((value) => (value === 'rtl' ? (this.isRtl = true) : (this.isRtl = false))),
      this.layout.isCollapsed.subscribe((value) => (this.isCollapsed = value)),
    );
  }

  chatboxClick() {
    this.layout.chatboxClick.emit();
    this.layout.isMobileMenuOpen.next(false);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
